import { Suspense } from 'react';

type Props = {
  children: React.ReactNode;
};

export default function SuspenseLoader({ children }: Props): JSX.Element {
  return <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>;
}
